var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoteWarning = function SvgIconVoteWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-hors-charte",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stopsign-alert",
    transform: "translate(-1472.853 -414.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "m1477.755 415.158-4.4 4.385v6.213l4.4 4.4h6.214l4.384-4.4v-6.213l-4.384-4.385Z",
    fill: "#e30000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 1.25,
    height: 5.625,
    rx: 0.625,
    transform: "translate(1480.228 418.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(1479.915 425.158)",
    fill: "#fff"
  }))));
};
export { SvgIconVoteWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1ob3JzLWNoYXJ0ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIvPgogIDxnIGlkPSJzdG9wc2lnbi1hbGVydCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0NzIuODUzIC00MTQuNjU3KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8yNDUiIGRhdGEtbmFtZT0iUGF0aCAyNDUiIGQ9Ik0xNDc3Ljc1NSw0MTUuMTU4bC00LjQsNC4zODV2Ni4yMTNsNC40LDQuNGg2LjIxNGw0LjM4NC00LjR2LTYuMjEzbC00LjM4NC00LjM4NVoiIGZpbGw9IiNlMzAwMDAiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNTYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDU2IiB3aWR0aD0iMS4yNSIgaGVpZ2h0PSI1LjYyNSIgcng9IjAuNjI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDgwLjIyOCA0MTguMjgzKSIgZmlsbD0iI2ZmZiIvPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV82MiIgZGF0YS1uYW1lPSJFbGxpcHNlIDYyIiBjeD0iMC45MzgiIGN5PSIwLjkzOCIgcj0iMC45MzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0NzkuOTE1IDQyNS4xNTgpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K";